import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetOrderStatisticsRequest,
  TGetOrderStatisticsResponse,
} from "./getOrderStatistics.schema";

export const getOrderStatistics =
  (axios: IAxiosInstance) =>
  async (
    params: TGetOrderStatisticsRequest
  ): Promise<TGetOrderStatisticsResponse> => {
    const response = await axios.noRetry.get<
      IApiResponse<TGetOrderStatisticsResponse>
    >("/api/orders/statistics", {
      params,
    });
    const resData = response.data;

    if (resData?.success) {
      return resData.data;
    }

    throw new Error("Error fetching order statistics");
  };
